import { CustomerUser } from '@texas/api/endpoints/customerUsersApi';
import { User } from '@texas/api/endpoints/userApi';
import { ReactSelectOption } from '@texas/types';
import { useTranslation } from 'react-i18next';
import { GroupBase } from 'react-select';

export function GetGroupedOptions(
  customerUsers: CustomerUser[] | null,
  allUsers: User[] | null,
): GroupBase<ReactSelectOption>[] {
  const { t } = useTranslation();

  return [
    {
      label: t('customer.brandTeam'),
      options:
        customerUsers?.map<ReactSelectOption>((u) => {
          return {
            label: `${u.userName} (${u.email})`,
            value: u.userId,
          };
        }) ?? [],
    },
    {
      label: t('article.productDevelopers.allUsers'),
      options:
        allUsers?.map<ReactSelectOption>((u) => {
          return {
            label: `${u.name} (${u.email})`,
            value: u.id,
          };
        }) ?? [],
    },
  ];
}
